// React
import { FunctionComponent } from "react"


// Subcomponents
import VehicleIncidentsSwitchView from "../VehicleIncidentsSwitchView/VehicleIncidentsSwitchView"

// Interfaces
import { I_ApprovalStatusCounts } from "src/components/approvals/interfaces"

// Styles
import "./VehicleIncidentsHeader.css"
import VehicleIncidentsFilters from "../VehicleIncidentsFilters/VehicleIncidentsFilters"

interface Props {
  statusCounts: I_ApprovalStatusCounts[] // Status count data used by the switch view component
}

/**
 * Renders the top header of the Vehicle Incidents page.
 * Includes the filters and the status-based view switcher.
 */
const VehicleIncidentsHeader: FunctionComponent<Props> = ({ statusCounts }) => {
  return (
    <div className="VehicleIncidentsHeader page-header">
      <div className="VehicleIncidentsHeaderLeft">
        <VehicleIncidentsFilters />
      </div>

      <div className="VehicleIncidentsHeaderRight">
        {/* Approval status tab-style view switching */}
        <VehicleIncidentsSwitchView statusCounts={statusCounts} />
      </div>
    </div>
  )
}

export default VehicleIncidentsHeader

